import React from 'react';
import PropTypes from 'prop-types';

const UdReassignIcon = ({ className, style, onClick }) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 24 24"
    width="28"
    height="28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    role="img"
    aria-hidden="true"
  >
    <circle cx="8" cy="6.2" r="2.3" stroke="currentColor" strokeWidth="1.7" />
    <path
      d="M4.2 14.4c.4-2.4 2-3.7 3.8-3.7s3.4 1.3 3.8 3.7"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
    <circle cx="17.4" cy="16.6" r="4.2" stroke="currentColor" strokeWidth="1.5" />
    <text
      x="17.4"
      y="17.5"
      textAnchor="middle"
      fill="currentColor"
      fontSize="5.4"
      fontWeight="700"
      fontFamily="Arial, sans-serif"
    >
      UD
    </text>
    <path
      d="M12.2 8.6h4.6"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
    <path
      d="M15.4 6.5L18 8.6 15.4 10.7"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

UdReassignIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

export default UdReassignIcon;
